module.exports = __webpack_public_path__ + "static/media/iconocargarvideo.f493b53a.svg";